import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Dropdown, Modal, Form } from 'react-bootstrap';
import { faArrowLeft, faBolt, faChevronDown, faArrowRight, faXmark, faCheck, faCircleCheck, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { withRFSToken } from '../../../../../Services/axios.js';
import { TRUCKORDERDETAILS, DELAWB } from '../../../../../Utils/conts';
import { toast } from 'react-toastify';

const ManageOffers = ({ data, reload }) => {
  let storedData = localStorage.getItem('TODetails');
  if (storedData) {
    storedData = JSON.parse(storedData)
  }

  const isMounted = useRef(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [confirmationData, setConfirmationData] = useState('');
  const [offerId, setOfferId] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalSection, setModalSection] = useState('');
  const [offers, setOffers] = useState([]); // storedData.truck_order_requests || 
  const [offerDetails, setOffersDetails] = useState([]);

  // useEffect(() => {
  //   if (isMounted.current) return;
  //   if (data) {
  //     setOffers(data.truck_order_requests);
  //   }
  //   isMounted.current = true;
  // }, []);

  const fetchDataGrid = async () => {
    const req_id = JSON.parse(localStorage.getItem('TODetails'));
    // console.log("req_id",req_id.truck_orders_id);

    try {
      const res = await withRFSToken.post('truck-request-list', { truck_orders_id: storedData.truck_orders_id })
      // .then(function (res) {
      if (res.data.response_code == 200) {
        const innerData = res.data.response_data;
        setOffers(innerData);
      }
      // });
    } catch (error) {
      console.error('Error fetching data:', error);
      // setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isMounted.current) return;
    fetchDataGrid();
    isMounted.current = true;
  }, []);

  const detailsClick = (data, sec) => {
    if (sec != 'cancel') {
      setOffersDetails(data)
      setShowModal(true);
      setModalSection(sec)
    } else {
      setOffersDetails(data)
      setShowConfirmation(true);
      setConfirmationData('C');
    }

  }
  const closeModal = () => {
    setShowModal(false);
    setModalSection('');
  }
  const handleSubmit = async (id, confirm) => {
    setConfirmationData(confirm);
    setShowConfirmation(true);
    setOfferId(id)
  }
  const handleConfirm = async (conf) => {
    if (conf === 'Y') {
      setIsLoading(true)
      try {
        const res = await withRFSToken.post('shipment-offer-acceptance', { truck_request_id: offerDetails.truck_request_id ?? offerId, response_status: confirmationData })
        // .then(function (res) {
        if (res.data.response_code == 200) {
          // const innerData = res.data.response_data;
          toast.success(res.data.response_msg)
          reload();
          fetchDataGrid();
          setShowConfirmation(false);
          setShowModal(false)
          setIsLoading(false)
        } else {
          toast.error(res.data.response_msg)
        }
        // });
      } catch (error) {
        console.error('Error fetching data:', error);
        // setIsLoading(false);
      }
    } else {
      setConfirmationData('')
      setShowConfirmation(false);
    }
  }


  return (
    <>
    {isLoading &&
        <div className='mvt loader-container' style={{ top: '0', height: '1084px', zIndex:'9999999' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
      }
    <div className='manager_offer'>
      {console.log('offerDetails', offerDetails)}
      <h2>Manage Offers</h2>
      <p>Manage all incoming offers below</p>

      <div className='manager_offer_box'>
        {offers?.map((offer, index) => (
          <React.Fragment key={index}>
            {offer.request_status == 'Requested' ?
              <div className='manage_list'>
                <div className='d-flex justify-content-between align-items-center order_rqst'>
                  <div><span>Trucker Name</span><h4>{offer?.trucker_name}</h4></div>
                  <div className='received'><span>{offer?.request_status}</span></div>
                  {offer.request_status !== 'Requested' ?
                    <div className='offer_price'>{offer?.currency_type} {offer?.response_amount}</div> : <div></div>
                  }
                </div>
                {/* {offer.request_status !== 'Requested' &&
                  <div className='d-flex justify-content-between offer_shr'>
                    <p>Offer shared : {offer?.updated_at}</p>
                    <Link to='#' onClick={() => detailsClick(offer)}>View Details</Link>
                  </div>
                } */}
              </div>
              :
              <div className='manage_list' key={index}>
                <div className='offer_box'>
                  <div className={
                    `d-flex justify-content-between align-items-center 
                    ${offer.request_status === 'Rejected' ? 'order_reject'
                      : offer.request_status === 'Booked' ? 'order_book'
                        : offer.request_status === 'No Availability' ? 'order_reject'
                          : offer.request_status === 'Offer Received' ? 'offerbg' : ''}`}
                  >
                    <div><span>Trucker Name</span><h4>{offer?.trucker_name}</h4></div>
                    <div className='received'><span>{offer?.request_status}</span></div>
                    <div className='offer_price'>{offer?.currency_type} {offer?.response_amount}</div>
                  </div>
                  <div className='d-flex justify-content-between offer_shr'>
                    <p>Offer shared : {offer?.updated_at}</p>
                    <Link to='#' onClick={() => detailsClick(offer, 'D')}>View Details</Link>
                  </div>
                  <div className='order_change'>
                    <h3>Order changes</h3>
                    {offer.order_changes.length > 0 ?
                      <>
                        <div className='ord_changes'>
                          {offer.order_changes.map((order) => (
                            <>
                              <div className='ord_box'>
                                <h4>{order.request_name}</h4>
                                <div className='truck_proposal'>
                                  <div className='org_data'>
                                    <p>Orginal </p>
                                    <span>{order.actual_request}</span>
                                  </div>
                                  <div>
                                    <FontAwesomeIcon icon={faArrowRight} />
                                  </div>
                                  <div className='pro_data'>
                                    <p>Proposal</p>
                                    <span>{order.changed_request}</span>
                                  </div>
                                </div>
                              </div>
                            </>
                          ))}
                        </div>
                      </>
                      : <p>No changes compared to orginal order</p>
                    }
                    <div className='text-center mt-3'>
                      {/* <Button className='accpt_offer' onClick={() => handleSubmit(offer.truck_request_id, 'A')}> <FontAwesomeIcon icon={faCheck} /> Accept Offer</Button> */}
                      {/* <Button className='reject_offer' onClick={() => handleSubmit(offer.truck_request_id, 'R')}><FontAwesomeIcon icon={faXmark} /> Reject Offer</Button> */}
                      {offer.request_status != 'Booked' ?
                        <>
                          <Button className='accpt_offer' onClick={() => detailsClick(offer, 'C')}> <FontAwesomeIcon icon={faCheck} /> Accept Offer</Button>
                          <Button className='reject_offer' onClick={() => detailsClick(offer, 'C')}><FontAwesomeIcon icon={faXmark} /> Reject Offer</Button>
                        </>
                        :
                        <>
                          {/* <Button className='reject_offer' onClick={() => detailsClick(offer, 'cancel')}><FontAwesomeIcon icon={faXmark} /> Cancel Offer</Button> */}
                        </>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
          </React.Fragment>
        ))}

      </div>
      <Modal className='raintrac' show={showConfirmation} onHide={() => setShowConfirmation(false)} centered>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <h2>{confirmationData === 'A'
            ? 'Accept Offer'
            : confirmationData === 'C'
              ? 'Cancel Truck Request'
              : 'Reject Offer'}  </h2>
          <p>{confirmationData === 'A'
            ? 'Accepting this offer will update the truck request status to Booked'
            : confirmationData === 'C'
              ? 'Would you like to cancel the truck request of '+offerDetails.trucker_name
              : 'Rejecting this offer will update the truck request status to Rejected'} 
            </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleConfirm('N')}>
            No
          </Button>
          <Button variant="primary" onClick={() => handleConfirm('Y')}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showModal} className='addfrom man_offer_dlt' onHide={closeModal} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>Truck Type</Modal.Title>
          <p>Please confirm</p>
        </Modal.Header>
        <Modal.Body>
          <>
            <div className='d-flex gap-3 align-items-center justify-content-between truck_type '>
              {offerDetails.requirement_response?.departure_date === 'Yes' ?
                <div className='type_green'><FontAwesomeIcon icon={faCircleCheck} /></div>
                : <div className='type_red'><FontAwesomeIcon icon={faCircleXmark} /></div>
              }
              <div className='dep'>Departure Time - {storedData.board_point}</div>
              <div className='dep_ans'>{storedData.departure_date}, {storedData.departure_time}</div>
              <div>
                <Form.Check
                  id='dept'
                  name='departure_date'
                  inline
                  label="Yes"
                  type='radio'
                  checked={offerDetails.requirement_response?.departure_date === 'Yes'}
                  disabled
                />
                <Form.Check
                  id='dept1'
                  name='departure_date'
                  inline
                  label="No"
                  type='radio'
                  checked={offerDetails.requirement_response?.departure_date === 'No'}
                  disabled
                />
              </div>
            </div>
            {offerDetails.requirement_response?.departure_date === 'No' && (
              <div className='ifno'>
                <p>Trucker Proposal Departure Time</p>
              </div>
            )}
            <div className='d-flex gap-3 align-items-center justify-content-between truck_type'>
              {offerDetails.requirement_response?.arrival_date === 'Yes' ?
                <div className='type_green'><FontAwesomeIcon icon={faCircleCheck} /></div>
                : <div className='type_red'><FontAwesomeIcon icon={faCircleXmark} /></div>
              }
              <div className='dep'>Arrival Time - {storedData.off_point}</div>
              <div className='dep_ans'>{storedData.arrival_date}, {storedData.arrival_time}</div>
              <div>
                <Form.Check
                  id='arv'
                  name='arrival_date'
                  inline
                  label="Yes"
                  type='radio'
                  checked={offerDetails.requirement_response?.arrival_date === 'Yes'}
                  disabled
                />
                <Form.Check
                  id='arv'
                  name='arrival_date'
                  inline
                  label="No"
                  type='radio'
                  checked={offerDetails.requirement_response?.arrival_date === 'No'}
                  disabled
                />
              </div>
            </div>
            {offerDetails.requirement_response?.arrival_date === 'No' && (
              <div className='ifno'>
                <p>Trucker Proposal Arrival Time</p>
              </div>
            )}
            <div className='d-flex gap-3 align-items-center justify-content-between truck_type'>
              {offerDetails.requirement_response?.truck_load === 'Yes' ?
                <div className='type_green'><FontAwesomeIcon icon={faCircleCheck} /></div>
                : <div className='type_red'><FontAwesomeIcon icon={faCircleXmark} /></div>
              }
              <div className='dep'>Truck Load</div>
              <div className='dep_ans'>{storedData.truck_load_type == 'L' ? 'LTL' : 'FTL'}</div>
              <div>
                <Form.Check
                  inline
                  name='truck_load'
                  label="Yes"
                  type='radio'
                  checked={offerDetails.requirement_response?.truck_load === 'Yes'}
                  disabled
                />
                <Form.Check
                  inline
                  name='truck_load'
                  label="No"
                  type='radio'
                  checked={offerDetails.requirement_response?.truck_load === 'No'}
                  disabled
                />
              </div>
            </div>
            {offerDetails.requirement_response?.truck_load === 'No' && (
              <div className='ifno'>
                <p>Trucker Proposal Truck Load {offerDetails.requirement_response?.truck_load_change === 'L' ? 'LTL' : 'FTL'}</p>
              </div>
            )}
            <div className='d-flex gap-3 align-items-center justify-content-between truck_type'>
              {offerDetails.requirement_response?.no_drivers === 'Yes' ?
                <div className='type_green'><FontAwesomeIcon icon={faCircleCheck} /></div>
                : <div className='type_red'><FontAwesomeIcon icon={faCircleXmark} /></div>
              }
              <div className='dep'>Number of Drivers</div>
              <div className='dep_ans'>{storedData.driver_number}</div>
              <div>
                <Form.Check inline
                  name='no_drivers'
                  label="Yes"
                  type='radio'
                  checked={offerDetails.requirement_response?.no_drivers === 'Yes'}
                  disabled
                />
                <Form.Check inline
                  name='no_drivers'
                  label="No"
                  type='radio'
                  checked={offerDetails.requirement_response?.no_drivers === 'No'}
                  disabled
                />
              </div>
            </div>
            {offerDetails.requirement_response?.no_drivers === 'No' && (
              <div className='ifno'>
                <p>Trucker Proposal Number of Drivers {offerDetails.requirement_response?.no_drivers}</p>
              </div>
            )}
            <div className='d-flex gap-3 align-items-center justify-content-between truck_type'>
              {offerDetails.requirement_response?.adr_required === 'Yes' ?
                <div className='type_green'><FontAwesomeIcon icon={faCircleCheck} /></div>
                : <div className='type_red'><FontAwesomeIcon icon={faCircleXmark} /></div>
              }
              <div className='dep'>ADR Required</div>
              <div className='dep_ans'>{storedData.adr == 1 ? 'Yes' : 'No'}</div>
              <div>
                <Form.Check
                  inline
                  name='adr_required'
                  label="Yes"
                  type='radio'
                  disabled
                  checked={offerDetails.requirement_response?.adr_required === 'Yes'}
                />
                <Form.Check
                  inline
                  name='adr_required'
                  label="No"
                  type='radio'
                  disabled
                  checked={offerDetails.requirement_response?.adr_required === 'No'}
                />
              </div>
            </div>
            {offerDetails.requirement_response?.adr_required === 'No' && (
              <div className='ifno'>
                <p>Trucker Proposal ADR Required {offerDetails.requirement_response?.adr_required_change == '0' ? 'No' : 'Yes'}</p>
              </div>
            )}
            <div className='d-flex gap-3 align-items-center justify-content-between truck_type'>
              {offerDetails.requirement_response?.temperature_control === 'Yes' ?
                <div className='type_green'><FontAwesomeIcon icon={faCircleCheck} /></div>
                : <div className='type_red'><FontAwesomeIcon icon={faCircleXmark} /></div>
              }
              <div className='dep'>Temperature Control</div>
              <div className='dep_ans'>
                {
                  storedData.temperature?.length === 1 ?
                    `(${storedData?.temperature_range_1_start}°C - ${storedData?.temperature_range_1_end}°C )`
                    : storedData.temperature?.length === 2 ?
                      `(${storedData.temperature_range_1_start}°C - ${storedData?.temperature_range_1_end}°C ), (${storedData?.temperature_range_2_start}°C - ${storedData.temperature_range_2_end}°C )`
                      : ''
                }</div>
              <div>
                <Form.Check
                  inline
                  name='temperature_control'
                  label="Yes"
                  type='radio'
                  disabled
                  checked={offerDetails.requirement_response?.temperature_control === 'Yes'}
                />
                <Form.Check
                  inline
                  name='temperature_control'
                  label="No"
                  type='radio'
                  disabled
                  checked={offerDetails.requirement_response?.temperature_control === 'No'}
                />
              </div>
            </div>
            {offerDetails.requirement_response?.temperature_control === 'No' && (
              <div className='ifno'>
                <p>Trucker Proposal Temperature Control {offerDetails.requirement_response.temperature_control_change == 'TC' ? 'Temperature' : offerDetails.requirement_response.temperature_control_change == 'MC' ? 'Multi-Temperature' : 'No'} -
                  {
                    offerDetails.requirement_response.temperature?.length === 1 ?
                      `(${offerDetails.requirement_response.temperature[0].temp1})`
                      : offerDetails.requirement_response.temperature?.length === 2 ?
                        `(${offerDetails.requirement_response.temperature[1].temp1}), (${offerDetails.requirement_response.temperature[1].temp2})`
                        : ''
                  }
                </p>
              </div>
            )}
            <div className='d-flex gap-3 align-items-center justify-content-between truck_type'>
              {offerDetails.requirement_response?.truck_material === 'Yes' ?
                <div className='type_green'><FontAwesomeIcon icon={faCircleCheck} /></div>
                : <div className='type_red'><FontAwesomeIcon icon={faCircleXmark} /></div>
              }
              <div className='dep'>Truck Material</div>
              <div className='dep_ans'>{storedData.truck_material == 'HC' ? 'Hard Cover' : storedData.truck_material == 'CS' ? 'Curtain Slider' : 'Flatbed Trailer'}</div>
              <div>
                <Form.Check
                  inline
                  name='truck_material'
                  label="Yes"
                  type='radio'
                  disabled
                  checked={offerDetails.requirement_response?.truck_material === 'Yes'}
                />
                <Form.Check
                  inline
                  name='truck_material'
                  label="No"
                  type='radio'
                  disabled
                  checked={offerDetails.requirement_response?.truck_material === 'No'}
                />
              </div>
            </div>
            {offerDetails.requirement_response?.truck_material === 'No' && (
              <div className='ifno'>
                <p>Trucker Proposal Truck Material {offerDetails.requirement_response?.truck_material}</p>
              </div>
            )}
            <div className='d-flex gap-3 align-items-center justify-content-between truck_type'>
              {offerDetails.requirement_response?.min_truck_height === 'Yes' ?
                <div className='type_green'><FontAwesomeIcon icon={faCircleCheck} /></div>
                : <div className='type_red'><FontAwesomeIcon icon={faCircleXmark} /></div>
              }
              <div className='dep'>Min. Truck Height (cm) </div>
              <div className='dep_ans'>{storedData.truck_height} cm</div>
              <div>
                <Form.Check
                  inline
                  name='min_truck_height'
                  label="Yes"
                  type='radio'
                  disabled
                  checked={offerDetails.requirement_response?.min_truck_height === 'Yes'}
                />
                <Form.Check
                  inline
                  name='min_truck_height'
                  label="No"
                  type='radio'
                  disabled
                  checked={offerDetails.requirement_response?.min_truck_height === 'No'}
                />
              </div>
            </div>
            {offerDetails.requirement_response?.min_truck_height === 'No' && (
              <div className='ifno'>
                <p>Trucker Proposal Min. Truck Height: {offerDetails.requirement_response.min_truck_height_change} cm</p>
              </div>
            )}
            <div className='d-flex gap-3 align-items-center justify-content-between truck_type'>
              {offerDetails.requirement_response?.rollerbed === 'Yes' ?
                <div className='type_green'><FontAwesomeIcon icon={faCircleCheck} /></div>
                : <div className='type_red'><FontAwesomeIcon icon={faCircleXmark} /></div>
              }
              <div className='dep'>Rollerbed </div>
              <div className='dep_ans'>{storedData.rollerbed == 'Y' ? 'Yes' : 'No'}</div>
              <div>
                <Form.Check
                  inline
                  name='rollerbed'
                  label="Yes"
                  type='radio'
                  disabled
                  checked={offerDetails.requirement_response?.rollerbed === 'Yes'}
                />
                <Form.Check
                  inline
                  name='rollerbed'
                  label="No"
                  type='radio'
                  disabled
                  checked={offerDetails.requirement_response?.rollerbed === 'No'}
                />
              </div>
            </div>
            {offerDetails.requirement_response?.rollerbed === 'No' && (
              <div className='ifno'>
                <p>Trucker Proposal Rollerbed {offerDetails.requirement_response?.rollerbed === 'Y' ? 'Yes' : 'No'}</p>
              </div>
            )}
            {modalSection === 'C' &&
              <div className='offer_box text-center mt-3' style={{ minHeight: '45px', border: 'none' }}>
                <Button className='accpt_offer' onClick={() => handleSubmit(offerDetails.truck_request_id, 'A')}> <FontAwesomeIcon icon={faCheck} /> Accept Offer</Button>
                <Button className='reject_offer' onClick={() => handleSubmit(offerDetails.truck_request_id, 'R')}><FontAwesomeIcon icon={faXmark} /> Reject Offer</Button>
              </div>
            }
          </>
        </Modal.Body>
      </Modal>
    </div>
    </>
  )
}

export default ManageOffers